export class PreLoader {
  #anchors: NodeListOf<HTMLElement> | null;
  #urls: string[] = [];
  constructor() {
    this.#anchors = document.querySelectorAll<HTMLElement>(
      'a:not([href^="#"]):not([target="_blank"])'
    );
  }
  init() {
    this.#anchors?.forEach((anchor) => {
      anchor.addEventListener('pointerover', this.#handleHover);
    });
  }
  dispose() {
    this.#anchors?.forEach((anchor) => {
      anchor.removeEventListener('pointerover', this.#handleHover);
    });
  }
  #handleHover = (event: PointerEvent) => {
    const anchor = event.currentTarget as HTMLAnchorElement;
    const href = anchor.href;
    if (this.#urls.includes(href)) return;
    this.#urls.push(href);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
  };
}
